import {CopilotIcon, ShieldLockIcon} from '@primer/octicons-react'

import imgBento1Bg from './bento-1-bg.webp'
import imgBento2Bg from './bento-2-bg.webp'
import imgBento3Bg from './bento-3-bg.webp'

export const bentoIcons = {
  'shield-lock': ShieldLockIcon,
  copilot: CopilotIcon,
} as const

const COPY = {
  bentos: [
    {
      backgroundImage: imgBento1Bg,
    },
    {
      backgroundImage: imgBento2Bg,
    },
    {
      backgroundImage: imgBento3Bg,
    },
  ],
} as const

export default COPY
